import { __decorate } from "tslib";
import HelixElement from '../../shared/types/helix-element.js';
import { customElement, property } from 'lit/decorators.js';
import { html, nothing } from 'lit';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { classMap } from 'lit/directives/class-map.js';
import { selectOptionStyles } from './select-option.styles.js';
import { consume } from '@lit/context';
import { selectedValueContext } from './select-context.js';
import { createRef, ref } from 'lit-html/directives/ref.js';
let HlxSelectOption = class HlxSelectOption extends HelixElement {
    constructor() {
        super(...arguments);
        this.id = crypto.randomUUID();
        this.contentSlot = createRef();
    }
    render() {
        const selected = this.value === this.selectedValue;
        return html `
            <button
                role="option"
                tabindex="-1"
                aria-selected=${selected}
                class=${classMap({
            'hlx-select-option': true,
            'hlx-select-option-selected': selected,
        })}>
                <div class="hlx-select-option-content">
                    <slot ${ref(this.contentSlot)}></slot>
                </div>
                ${selected ?
            html `
                        <div class="hlx-select-option-icon">
                            <hlx-icon decorative name="check" size="16"></hlx-icon>
                        </div>
                    `
            : nothing}
            </button>
        `;
    }
    connectedCallback() {
        super.connectedCallback();
        this.emitOptionSelectEvent = this.emitOptionSelectEvent.bind(this);
        this.addEventListener('click', this.emitOptionSelectEvent);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.addEventListener('keydown', this.handleKeyPress);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener('click', this.emitOptionSelectEvent);
        this.removeEventListener('keydown', this.handleKeyPress);
    }
    getRenderedContent() {
        return html `
            <div class="hlx-select-option-content">
                ${this.contentSlot.value?.assignedNodes().map((node) => node.cloneNode(true))}
            </div>
        `;
    }
    emitOptionSelectEvent() {
        this.emit('hlx-select-option-selected', { value: this.value }, { bubbles: true });
    }
    handleKeyPress(event) {
        if (event.code === 'Space' || event.code === 'Enter') {
            event.stopPropagation();
            event.preventDefault();
            this.emitOptionSelectEvent();
        }
    }
};
HlxSelectOption.shadowRootOptions = { ...HelixElement.shadowRootOptions, delegatesFocus: true };
HlxSelectOption.styles = [componentStyles, selectOptionStyles];
__decorate([
    consume({ context: selectedValueContext, subscribe: true }),
    property({ type: String, attribute: false })
], HlxSelectOption.prototype, "selectedValue", void 0);
__decorate([
    property({ type: String, reflect: true })
], HlxSelectOption.prototype, "id", void 0);
__decorate([
    property({ type: String })
], HlxSelectOption.prototype, "value", void 0);
HlxSelectOption = __decorate([
    customElement('hlx-select-option')
], HlxSelectOption);
export { HlxSelectOption };
//# sourceMappingURL=select-option.js.map